import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Icon from '../components/Icon';
import ProfileCard, { CardGrid } from '../components/ProfileCard';
import { EmptyState, Page, PageHead, Photo, SkeletonGrid } from '../components/UI';
import { api } from '../utils/api';
import { timeAgo } from '../utils/format';

export function Shortlist() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api('/profiles/shortlist').then((d) => setItems(d.items)).catch(() => setItems([]));
  }, []);
  return (
    <Page>
      <div className="container">
        <PageHead eyebrow="Saved" title="Your shortlist" sub="Profiles you've starred to revisit." />
        {!items ? <SkeletonGrid /> : items.length ? <CardGrid items={items} /> : (
          <EmptyState icon="star" title="Nothing saved yet" text="Tap the ★ on any profile to keep it here for later." action={<Link to="/matches" className="btn btn--primary">Explore matches</Link>} />
        )}
      </div>
    </Page>
  );
}

export function Visitors() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api('/profiles/visitors').then(setData).catch(() => setData({ items: [] }));
  }, []);
  return (
    <Page>
      <div className="container">
        <PageHead eyebrow="Visitors" title="Who viewed your profile" sub={data ? `${data.total} people visited recently` : ''} />
        {!data ? <SkeletonGrid /> : !data.items.length ? (
          <EmptyState icon="eye" title="No visitors yet" text="A complete profile with photos attracts more visitors." action={<Link to="/me/edit" className="btn btn--primary">Improve my profile</Link>} />
        ) : (
          <>
            {data.locked && (
              <motion.div className="promo" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
                <div className="promo__art"><Icon name="eye" size={34} /></div>
                <div>
                  <h3>{data.total} people are curious about you</h3>
                  <p className="muted">Upgrade to see exactly who viewed your profile and reach out first.</p>
                </div>
                <Link to="/premium" className="btn btn--gold shine">Reveal visitors</Link>
              </motion.div>
            )}
            <CardGrid
              items={data.items}
              render={(p) => (
                <div key={p.profileId} className="visitor">
                  {p.locked ? (
                    <Link to="/premium" className="pcard pcard--compact visitor__locked">
                      <div className="pcard__media">
                        <Photo src={p.photo} alt="" locked />
                        <div className="pcard__shade" />
                        <div className="pcard__info">
                          <h3>{p.name}</h3>
                          <p>{[p.age && `${p.age} yrs`, p.city].filter(Boolean).join(' · ')}</p>
                        </div>
                      </div>
                    </Link>
                  ) : (
                    <ProfileCard p={p} compact />
                  )}
                  <small className="visitor__when"><Icon name="eye" size={12} /> {timeAgo(p.viewedAt)}{p.times > 1 ? ` · ${p.times} visits` : ''}</small>
                </div>
              )}
            />
          </>
        )}
      </div>
    </Page>
  );
}
